import React from 'react';

export const WhyChooseUs: React.FC = () => {
  const reasons = [
    {
      icon: 'ri-medal-line',
      title: 'Garden Apartment Specialists',
      description: 'Unlike general real estate investors, we focus specifically on garden-style multifamily properties. This specialization means we understand the unique characteristics, operating dynamics, and value drivers of garden apartments better than generalist buyers.'
    },
    {
      icon: 'ri-funds-box-line',
      title: 'Strong Financial Position',
      description: 'We have substantial capital available and established lending relationships, enabling us to close transactions quickly without financing contingencies. Our financial strength means certainty of closing for sellers.'
    },
    {
      icon: 'ri-team-line',
      title: 'Experienced Team',
      description: 'Our team includes professionals with decades of combined experience in multifamily acquisitions, property management, construction, and real estate finance. We\'ve seen every situation and can handle complex transactions smoothly.'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Fair and Transparent',
      description: 'We provide honest assessments and fair offers based on realistic property evaluations. No lowball offers or last-minute renegotiations. Our reputation is built on integrity and treating sellers with respect.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Efficient Process',
      description: 'We\'ve streamlined our acquisition process to minimize seller burden and time commitment. Our team handles the complexity while keeping you informed at every step. We close on time, every time.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Personalized Service',
      description: 'You\'ll work directly with decision-makers, not junior staff or intermediaries. We take time to understand your specific situation and goals, then structure transactions that work for you.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Why Garden Apartment Owners Choose Us
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            We've built our business on expertise, integrity, and delivering exceptional experiences for garden apartment sellers.
          </p>
        </div>

        <div className="mb-16">
          <div className="relative overflow-hidden rounded-2xl shadow-2xl">
            <img
              src="https://public.readdy.ai/ai/img_res/185b6f37997638409b79939b4ddc9e24.jpg"
              alt="Professional Real Estate Team"
              className="w-full h-[450px] object-cover object-top"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-lg p-8 border border-gray-200 hover:shadow-xl hover:border-orange-300 transition-all duration-300"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center mb-6">
                <i className={`${reason.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {reason.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-10 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">
            Experience the Difference
          </h3>
          <p className="text-xl mb-8 text-gray-300 max-w-2xl mx-auto">
            Discover why hundreds of garden apartment owners have chosen us for their property sales. Let's discuss how we can help you achieve your goals.
          </p>
          <a
            href="#get-offer"
            className="inline-block px-10 py-5 bg-orange-500 text-white font-bold rounded-lg hover:bg-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl text-lg whitespace-nowrap"
          >
            Contact Us Today
          </a>
        </div>
      </div>
    </section>
  );
};